import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { trackEvent } from "utils/analytics";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("access_token");
    const storedUser = localStorage.getItem("user");
    setToken(storedToken);
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse user from localStorage", e);
      }
    }
    setIsInitializing(false);
  }, []);

  const login = useCallback((newToken, userData, method = "password") => {
    if (typeof localStorage !== "undefined") {
      try {
        localStorage.setItem("access_token", newToken);
        localStorage.setItem("user", JSON.stringify(userData));
        
      } catch (err) {
        console.warn("⚠️ localStorage 無法寫入，將略過儲存：", err);
      }
    } else {
      console.warn("⚠️ localStorage 不可用，可能是無痕模式或隱私瀏覽器");
    }

    setToken(newToken); 
    setUser(userData);
    // GA4：所有登入入口統一送一次 login；method 預設 password，Google 入口傳 "google"
    trackEvent("login", { method });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("pendingVerifyEmail");
    localStorage.removeItem("pendingToken");
    localStorage.removeItem("signinIntroDismissed_v1");
    localStorage.removeItem("referralCode");
    localStorage.removeItem("firstLogin");
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, isAuthenticated: !!token, isInitializing, login, logout }}>

      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);
